{
  "boxes": {
    "title": "الصناديق",
    "add": "إضافة صندوق",
    "columns": {
      "name": "الاسم",
      "code": "الرمز",
      "branch": "الفرع",
      "balance": "الرصيد الحالي",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}",
      "ledger": "كشف الحركات",
      "addBalance": "إضافة رصيد",
      "withdrawBalance": "سحب رصيد",
      "moveBalance": "نقل رصيد"
    },
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "statusConfirmDeactivateNote": "تعطيله يمنع استخدامه في حركات جديدة فقط ويحافظ على سجله.",
    "deleteConfirmTitle": "تأكيد الحذف",
    "deleteConfirmDescription": "سيتم حذف الصندوق \"{{name}}\". لا يمكن التراجع عن هذا الإجراء.",
    "deleted": "تم حذف الصندوق بنجاح",
    "statusChanged": "تم تغيير حالة الصندوق بنجاح",
    "drawer": {
      "createTitle": "إضافة صندوق",
      "editTitle": "تعديل صندوق",
      "createDescription": "أدخل بيانات الصندوق الجديد.",
      "editDescription": "تحديث بيانات هذا الصندوق.",
      "created": "تم إنشاء الصندوق بنجاح",
      "updated": "تم تحديث الصندوق بنجاح",
      "fields": {
        "branch": "الفرع",
        "name": "الاسم",
        "code": "الرمز",
        "openingBalance": "الرصيد الافتتاحي"
      }
    }
  },
  "bankAccounts": {
    "title": "الحسابات البنكية",
    "add": "إضافة حساب بنكي",
    "columns": {
      "bankName": "اسم البنك",
      "accountName": "اسم الحساب",
      "accountNumber": "رقم الحساب / IBAN",
      "branches": "الفروع المسموحة",
      "balance": "الرصيد الحالي",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}",
      "ledger": "كشف الحركات",
      "addBalance": "إضافة رصيد",
      "withdrawBalance": "سحب رصيد",
      "moveBalance": "نقل رصيد"
    },
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "statusConfirmDeactivateNote": "تعطيله يمنع استخدامه في حركات جديدة فقط ويحافظ على سجله.",
    "deleteConfirmTitle": "تأكيد الحذف",
    "deleteConfirmDescription": "سيتم حذف الحساب \"{{name}}\". لا يمكن التراجع عن هذا الإجراء.",
    "deleted": "تم حذف الحساب البنكي بنجاح",
    "statusChanged": "تم تغيير حالة الحساب البنكي بنجاح",
    "drawer": {
      "createTitle": "إضافة حساب بنكي",
      "editTitle": "تعديل حساب بنكي",
      "createDescription": "أدخل بيانات الحساب البنكي الجديد.",
      "editDescription": "تحديث بيانات هذا الحساب البنكي.",
      "created": "تم إنشاء الحساب البنكي بنجاح",
      "updated": "تم تحديث الحساب البنكي بنجاح",
      "accountNumberOrIban": "أدخل رقم الحساب أو IBAN",
      "fields": {
        "bankName": "اسم البنك",
        "accountName": "اسم الحساب",
        "accountNumber": "رقم الحساب",
        "iban": "IBAN",
        "branches": "الفروع المسموحة",
        "openingBalance": "الرصيد الافتتاحي"
      },
      "invalidIban": "رقم IBAN غير صالح"
    }
  },
  "validation": {
    "amountDecimals": "لا يمكن أن يحتوي المبلغ على أكثر من خمسة أرقام عشرية",
    "dateNotFuture": "التاريخ يجب ألا يكون في المستقبل"
  },
  "balanceAdjust": {
    "titleIn": "إضافة رصيد",
    "titleOut": "سحب رصيد",
    "descriptionIn": "أضف رصيدا يدويا إلى {{holder}}.",
    "descriptionOut": "اسحب رصيدا يدويا من {{holder}}.",
    "currentBalance": "الرصيد الحالي: {{balance}}",
    "resultingBalance": "الرصيد بعد العملية: {{balance}}",
    "fields": {
      "amount": "المبلغ",
      "reason": "السبب",
      "date": "التاريخ"
    },
    "commitIn": "إضافة رصيد",
    "commitOut": "سحب رصيد",
    "addedSuccess": "تمت إضافة الرصيد بنجاح",
    "withdrawnSuccess": "تم سحب الرصيد بنجاح"
  },
  "balanceMove": {
    "title": "نقل رصيد",
    "description": "انقل رصيدا بين صندوق وحساب بنكي.",
    "from": "من",
    "to": "إلى",
    "resultingBalanceFrom": "رصيد {{holder}} بعد العملية: {{balance}}",
    "resultingBalanceTo": "رصيد {{holder}} بعد العملية: {{balance}}",
    "fields": {
      "amount": "المبلغ",
      "reason": "السبب",
      "to": "إلى"
    },
    "commit": "نقل رصيد",
    "success": "تم نقل الرصيد بنجاح"
  },
  "ledger": {
    "back": "رجوع",
    "currentBalance": "الرصيد الحالي: {{balance}}",
    "export": "تصدير إلى Excel",
    "exporting": "تصدير...",
    "columns": {
      "date": "التاريخ",
      "type": "النوع",
      "in": "وارد",
      "out": "صادر",
      "balanceAfter": "الرصيد بعد الحركة",
      "employee": "الموظف",
      "customer": "العميل",
      "reference": "المرجع",
      "reason": "السبب"
    },
    "filters": {
      "from": "من تاريخ",
      "to": "إلى تاريخ",
      "type": "النوع",
      "allTypes": "كل الأنواع"
    },
    "types": {
      "OPENING": "رصيد افتتاحي",
      "TRANSFER": "حوالة",
      "TRANSFER_CANCEL": "إلغاء حوالة",
      "TRANSFER_EDIT": "تعديل حوالة",
      "ADJUST_IN": "إضافة رصيد",
      "ADJUST_OUT": "سحب رصيد",
      "MOVE": "نقل رصيد"
    }
  }
}
